import axios from "axios";

interface ipAddrInterface {
	local: string;
	work: string;
	vpn: string;
}

const ipAddr: ipAddrInterface = {
	local: "http://localhost:4000",
	work: "http://192.168.1.235:4000",
	vpn: "http://10.8.0.6:4000",
};

const debug = process.env.NODE_ENV !== "production";
const API_HOST = process.env.API_HOST;
const baseURL = debug ? ipAddr.local : "https://cabinet.wapi.link:3005"; //todo  разобраться и поправить на переменную окружения

const api = axios.create({ baseURL, withCredentials: true });

export default api;
